'use client'

import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect } from 'react'
import { completeNavigationTelemetry } from '@/lib/observability/navigation-telemetry'

/** Mount beside the RUM router under Suspense; a commit is not page readiness. */
export function NavigationTelemetry(): null {
  const pathname = usePathname()
  const query = useSearchParams().toString()
  useEffect(() => {
    if (pathname) {
      completeNavigationTelemetry(pathname, query ? `?${query}` : '')
    }
  }, [pathname, query])
  return null
}
